var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletIcons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 4.16669V15.4167C2.5 16.3372 3.24619 17.0834 4.16667 17.0834H15.8333C16.7538 17.0834 17.5 16.3372 17.5 15.4167V7.08335C17.5 6.16288 16.7538 5.41669 15.8333 5.41669H5.83333",
    stroke: "#888888",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4993 9.58331H14.9993C14.5391 9.58331 14.166 9.9564 14.166 10.4166V12.0833C14.166 12.5436 14.5391 12.9166 14.9993 12.9166H17.4993",
    stroke: "#888888",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 4.16669C2.5 3.47633 3.05964 2.91669 3.75 2.91669H13C14.1046 2.91669 15 3.81212 15 4.91669V5.41669H3.75C3.05964 5.41669 2.5 4.85704 2.5 4.16669Z",
    stroke: "#888888",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcons);
export default __webpack_public_path__ + "static/media/Wallet-icons.7ec8fd3843fbf351c1c63120741968a6.svg";
export { ForwardRef as ReactComponent };